import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import Axios from "axios";

//ACTIONS
import * as GS_pageSettingsActions from "../../../../../store/actions/globalSettings/GS_pageSettings";
import * as MediaActions from "../../../../../store/actions/media";

function SegmentedMenu(props) {
    const dispatch = useDispatch();

    useEffect(() => {
        BuildMenu();
    }, [props]);

    function handleLibraryClicked(library) {
        dispatch(GS_pageSettingsActions.SetPodToLayout(`PDF Library - ${library.name}`, "false", "CPOD_PDFLIBRARY_FREND", "", library.uuid));

        dispatch(GS_pageSettingsActions.ItemsViewer_Close());
    }

    function BuildMenu() {
        const items = [];
        Axios.post("/pods/pdfLibrary/loadLibraries")
            .then((res) => {
                const data = res.data;
                console.log(data);
                if (data.error == "null") {
                    data.libraries.forEach((library) => {
                        items.push({ title: library.name, method: handleLibraryClicked.bind(this, library) });
                    });

                    const menu = {
                        title: "PDF Library",
                        backBtn: true,
                        items: items
                    };

                    dispatch(GS_pageSettingsActions.ItemsViewer_SetMenu(menu));
                }
            })
            .catch((err) => console.log(err));
    }

    return <div></div>;
}

export default SegmentedMenu;
